import { Injectable } from '@angular/core';
import { ApiService, PagedResultGeneric } from '../../shared/index';
import { CalendarFormSubmission } from './calendar-form-submission.model';
import { EventListHtDto } from './event-list-ht.dto';
import { EventSubmissionSearch } from './event-submission-search.model';

@Injectable({
  providedIn: 'root',
})
export class EventSubmissionService {
  public _apiService: ApiService;

  public constructor(apiService: ApiService) {
    this._apiService = apiService;
  }

  public getSubmissionFormSettings(): Promise<CalendarFormSubmission> {
    return this._apiService.get('Event/SubmissionFormSettings?settingName=CommunityEventSubmission');
  }

  public postSubmissionFormSettings(data: CalendarFormSubmission, settingBatch?: string): Promise<void> {
    let url = 'Event/SubmissionFormSettings?settingName=CommunityEventSubmission';
    if (settingBatch) {
      url += '&settingBatch=' + settingBatch;
    }
    return this._apiService.post(url, data);
  }

  public getEventSubmissions(search: EventSubmissionSearch, forceRefresh?): Promise<PagedResultGeneric<EventListHtDto>> {
    const cacheOptions = forceRefresh ? this._apiService.getDefaultApiCacheOptionsForNoCache() : null;
    return this._apiService.getPaged('event/geteventsubmissions', search, cacheOptions);
  }

  public updateEventSubmission(eventSubmission: EventListHtDto): Promise<void> {
    return this._apiService.put('Event/UpdateEventSubmission', eventSubmission);
  }

  public approveEventSubmission(id: number): Promise<void> {
    return this._apiService.put(`Event/${id}/ApproveEventSubmission`, null);
  }

  public rejectEventSubmission(id: number): Promise<void> {
    return this._apiService.put(`Event/${id}/RejectEventSubmission`, null);
  }

  public deleteEventSubmission(eventSubmissionID: number): Promise<void> {
    return this._apiService.delete('Event/DeleteEventSubmission?EventSubmissionID=' + eventSubmissionID);
  }

  public searchExportToCsv(search: EventSubmissionSearch): Promise<string> {
    return this._apiService.post('event/geteventsubmissions/export', search);
  }

  public getEventSubmission(id: number): Promise<EventListHtDto> {
    return this._apiService.get(`event/submission/${id}`);
  }
}
